<form [formGroup]="form" (ngSubmit)="submit()" class="mx-auto flex w-full max-w-4xl flex-col gap-4">
    <fb-section-card [title]="'FUNPAY_PICK_ACCOUNT' | translate" [description]="'FUNPAY_PICK_ACCOUNT_DESC' | translate">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" role="radiogroup">
            @for (account of accounts(); track account.clientId) {
                @let isSelected = selected() === account.clientId;
                <button
                    type="button"
                    role="radio"
                    [attr.aria-checked]="isSelected"
                    class="text-left flex gap-3 p-4 rounded-md border transition-colors"
                    [class]="isSelected ? 'border-brand bg-concern-accent' : 'border-border bg-surface hover:border-border-strong'"
                    (click)="selected.set(account.clientId)">
                    <span
                        class="size-9 shrink-0 rounded-md flex items-center justify-center text-lg"
                        [class]="isSelected ? 'bg-brand text-brand-ink' : 'bg-surface-2 text-text-2'">
                        <i class="ph ph-bank"></i>
                    </span>
                    <span class="flex flex-col gap-1 min-w-0">
                        <span class="font-semibold text-text truncate flex items-center gap-2">
                            {{ account.legalName }}
                            @if (isSelected) {
                                <i class="ph-fill ph-check-circle text-brand"></i>
                            }
                        </span>
                        <span class="text-xs text-text-muted">{{ 'FUNPAY_USED_BY' | translate: { venue: account.clientName } }}</span>
                        <span class="text-xs inline-flex items-center gap-1 text-concern-success-title">
                            <i class="ph ph-seal-check"></i>
                            {{ 'FUNPAY_VERIFIED' | translate }}
                        </span>
                    </span>
                </button>
            }
        </div>
    </fb-section-card>

    <fb-section-card [title]="'FUNPAY_STORE_DETAILS' | translate" [description]="'FUNPAY_STORE_DETAILS_DESC' | translate">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label class="flex flex-col gap-1.5">
                <span class="text-sm font-medium text-text">{{ 'FUNPAY_SHOPPER_STATEMENT' | translate }}</span>
                <input pInputText formControlName="shopperStatement" [maxlength]="maxStatement" [invalid]="invalid('shopperStatement')" />
                <small class="text-text-muted">{{ 'FUNPAY_SHOPPER_STATEMENT_HELP' | translate }}</small>
            </label>
            <label class="flex flex-col gap-1.5">
                <span class="text-sm font-medium text-text">{{ 'FUNPAY_VENUE_PHONE' | translate }}</span>
                <input pInputText type="tel" formControlName="phoneNumberVenue" [invalid]="invalid('phoneNumberVenue')" />
                <small [class]="invalid('phoneNumberVenue') ? 'text-red-500' : 'text-text-muted'">{{ 'FUNPAY_VENUE_PHONE_HELP' | translate }}</small>
            </label>
            <label class="flex flex-col gap-1.5 md:col-span-2">
                <span class="text-sm font-medium text-text">{{ 'ADDRESS' | translate }}</span>
                <input pInputText formControlName="street" [invalid]="invalid('street')" />
            </label>
            <label class="flex flex-col gap-1.5">
                <span class="text-sm font-medium text-text">{{ 'ZIP_CODE' | translate }}</span>
                <input pInputText formControlName="postalCode" [invalid]="invalid('postalCode')" />
            </label>
            <label class="flex flex-col gap-1.5">
                <span class="text-sm font-medium text-text">{{ 'CITY' | translate }}</span>
                <input pInputText formControlName="city" [invalid]="invalid('city')" />
            </label>
        </div>
    </fb-section-card>

    @if (submitError(); as error) {
        <p-message severity="error">{{ error | translate }}</p-message>
    }

    <div class="flex items-center justify-between gap-2">
        <button pButton type="button" severity="secondary" [text]="true" (click)="back.emit()">
            <i class="ph ph-arrow-left"></i>
            <span>{{ 'FUNPAY_BACK' | translate }}</span>
        </button>
        <button pButton type="submit" [loading]="submitting()" [disabled]="!canSubmit()">
            <i class="ph ph-link"></i>
            <span>{{ 'FUNPAY_LINK_ACCOUNT' | translate }}</span>
        </button>
    </div>
</form>
